import { Helmet } from "react-helmet-async";
import { fileUrl } from "../../lib/api";

const SITE = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
const DEFAULT_IMG = "/og-image.jpg";

const abs = (u) => {
  if (!SITE || !u) return "";
  if (/^https?:\/\//.test(u)) return u;
  return u.startsWith("/api/") ? fileUrl(u) : `${SITE}${u}`;
};

export const Seo = ({ title, description, path = "/", image, type = "website", jsonLd, noindex = false }) => {
  const url = SITE ? `${SITE}${path}` : "";
  const img = abs(image || DEFAULT_IMG);
  const isDefaultImg = !image;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {img && <meta property="og:image" content={img} />}
      {img && isDefaultImg && <meta property="og:image:width" content="1200" />}
      {img && isDefaultImg && <meta property="og:image:height" content="630" />}
      <meta name="twitter:card" content={isDefaultImg ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const crumbsLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});

export const absUrl = abs;
export const SITE_URL = SITE;
